<template>
  <NuxtLayout>
    <div class="main-page">
      <KinoMain v-if="displayedModule?.name === ModuleTypes.EModuleNames.KINO" />

      <template v-else>
        <CustomPageModule
          v-if="
            companyStore.company?.mainCustomPage &&
            (!companyStore.company?.mainCustomPage.isHidden ||
              (companyStore.company?.mainCustomPage?.isHidden && userStore.isAdmin))
          "
          :id="companyStore.company.mainCustomPage.id"
          :is-edit-enabled="userStore.isEditEnabled && userStore.isAdmin"
        />

        <SitesTemplatesModal v-if="isSiteTemplatesModal" />
      </template>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';

import { useSiteTemplates } from '@/entities/site-template';
import { Types as ModuleTypes } from '@/entities/module';

import { CustomPageModule } from '@/widgets/custom-page';
import SitesTemplatesModal from '@/widgets/sites-templates/ui/SitesTemplatesModal.vue';
import KinoMain from '@/pages/kino/Main.vue';

const userStore = useUserStore();
const companyStore = useCompanyStore();

const seoTags = computed(() => companyStore.company?.seo);

useHead({
  title: companyStore.company?.name,
  meta: seoTags.value
    ?.filter((tag) => tag.name && tag.value)
    .map((tag) => ({
      name: tag.name,
      content: tag.value,
    })),
});

const { fetchTemplates } = useSiteTemplates();
const { templates } = storeToRefs(useSiteTemplates());

const route = useRoute();

const isSiteTemplatesModal = ref(false);

const displayedModule = computed(() => {
  const modules = companyStore.company?.modules || [];
  return modules.find((module) => module.isEnabled && module.isDisplayOnMain);
});

watch(
  () => route.query,
  async (routeQuery) => {
    if (routeQuery?.settings === 'site-templates') {
      await fetchTemplates();

      if (templates.value.length) {
        isSiteTemplatesModal.value = true;
      }
    } else {
      isSiteTemplatesModal.value = false;
    }
  },
  { immediate: true },
);
</script>

<style scoped lang="scss">
.main-page {
  width: 100%;
}
</style>
